import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@material-ui/core';

import useStyles from '../styles';

const ImportContactsInfoBox = ({ onDownloadTemplate }) => {
  const classes = useStyles();

  return (
    <div>
      <div>Supported Formats:</div>
      <ul className={classes.formatsList}>
        <li>
          <Link target="_blank" href="https://entra.microsoft.com/">
            Microsoft Entra
          </Link>
          <span>
            <span>&nbsp;under the&nbsp;</span>
            <b>Users -&gt; All Users</b>
            <span>&nbsp;page</span>
          </span>
        </li>
        <li>
          <Link target="_blank" href="https://admin.microsoft.com/">
            Microsoft 365
          </Link>
          <span>
            <span>&nbsp;under the&nbsp;</span>
            <b>Users -&gt; Active Users</b>
            <span>&nbsp;page</span>
          </span>
        </li>
        <li>Google Workspace</li>
        <li>
          <span>The MSP Process CSV format (</span>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <Link style={{ cursor: 'Pointer' }} onClick={onDownloadTemplate}>
            download here
          </Link>
          <span>)</span>
        </li>
      </ul>
    </div>
  );
};

ImportContactsInfoBox.propTypes = {
  onDownloadTemplate: PropTypes.func.isRequired,
};

export default ImportContactsInfoBox;
